// removed by extract-text-webpack-plugin
module.exports = {"button":"index__button___3strT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ListTopButton/index.less
// module id = 1157
// module chunks = 3